<style>
    table.tb1
    {
        border-collapse:collapse;
    }

    table.tb1 th, table.tb1 td
    {
        border: 1px solid #ccc;
    }

    table.tb1 th{
        text-align: center;
        font-weight: bold;
        padding:5px;
    }

    .canceled{
        text-decoration:line-through
    }

    .hide{
        display:none;
    }
</style>

<template>
    <div id="ScheduleSection">
        <card>
            <div style="min-height:300px">
                <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection"
                      @keyup.enter.native="doSearch()">
                    <FormItem prop="daterange" label="时间范围" :label-width="60">
                        <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                    style="width: 240px"
                                    format="yyyy-MM-dd" @on-change="searchForm.daterange=$event"></DatePicker>
                    </FormItem>
                    <Form-item prop="state" label="状态" :label-width="60">
                        <Select v-model="searchForm.state" style="width: 250px" clearable>
                            <Option :value="1">未开始</Option>
                            <Option :value="2">已结束</Option>
                            <Option :value="3">已取消</Option>
                        </Select>
                    </Form-item>
                    <FormItem>
                        <Button type="primary" @click="doSearch" size="small">搜索</Button>
                        <Button type="primary" @click="showCancelWin(2,null)" size="small" style="margin-left:10px;">批量取消</Button>
                        <Button type="primary" @click="batchDelete" size="small" style="margin-left:10px;">批量删除</Button>
                    </FormItem>
                </Form>
                <Table :columns="columns" :data="data" :loading="dataLoading" @on-selection-change="selectChange"></Table>
                <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total show-sizer
                      @on-page-size-change="pageSizeChange" @on-change="changePage" :page-size="size"></Page>
            </div>
        </card>
        <cancelWin ref="cancelWin" @on-cancel-success="onCancelSuccess" :mode="2"></cancelWin>
    </div>
</template>
<script>
  import cancelWin from '../schedule/cancelWin'
  import moment from 'moment';
  moment.locale('zh-cn');

  export default {
    name: 'student_schedule',
    components: {
      cancelWin
    },
    data() {
      return {
        showModel:"list",
        checkData:[],
        title:'',
        size:20,
        searchForm: {
          daterange: [
            moment(new Date()).subtract(7, 'days').format("YYYY-MM-DD"),
            moment(new Date()).add(7, 'days').format("YYYY-MM-DD")
          ],
          state:null
        },
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '校区',
            key: 'zoneName'
          },
          {
            title: '学员',
            key: 'studentName'
          },
          {
            title: '上课时间',
            key: 'classdate',
            render: (h, params) => {
              return h('div', [
                h('div', params.row.classdate),
                h('div', params.row.begin + "-" + params.row.end)
              ]);
            }
          },
          {
            title: '班级/一对一',
            width: 210,
            render: (h, params) => {
              let className = '';
              if (params.row.className) {
                if (params.row.courseType == 1) {
                  className = '【一对一】' + params.row.className;
                } else {
                  className = '【班课】' + params.row.className;
                }
              } else {
                className = '【一对一】' + params.row.courseName + ' | ' + params.row.studentName
              }

              return h('div', className);
            }
          },
          {
            title: '教师',
            key: 'teacherName'
          },
          {
            title: '状态',
            key: 'state',
            render: (h, params) => {
              if (params.row.state == 1) {
                return h('Tag', {}, '未开始');
              } else if (params.row.state == 2) {
                return h('Tag',
                  {
                    props: {
                      color: 'success'
                    },
                  }, '已结束');
              } else if (params.row.state == 3) {
                return h('Tag',
                  {
                    props: {
                      color: 'warning'
                    },
                  }, '已取消');
              } else if (params.row.state == 4) {
                return h('Tag',
                  {
                    props: {
                      color: 'error'
                    },
                  }, '课时不足');
              } else {
                return h('Tag',
                  {
                    props: {
                      color: 'error'
                    },
                  }, '系统异常');
              }
            }
          },
          {
            title: '操作',
            width: 180,

            render: (h, params) => {
              let self = this;

              let opArray = [];

              if (params.row.state == 1){
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type:'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.showCancelWin(1,params.row.id);
                    }
                  }
                }, '取消单次'));
              }

              if (params.row.state == 1) {
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type: 'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delOneTime(params.row);
                    }
                  }
                }, '删除单次'));
              }

              return h('ButtonGroup', opArray);

            }
          }
        ],
        data: [],
        dataLoading: false,
        totalPage: 0,
        pageTotalNum: 0,
        pageCurrent: 1,
      }
    },
    methods: {
      showCancelWin(type,id){
        let ids = null;
        if (type == 2){
          let classRecordArray = this.checkData.filter(item => item.state===1 );
          let tobeDelArray = [];
          classRecordArray.forEach(ele=>{
            tobeDelArray.push(ele.id);
          });
          ids = tobeDelArray.join(",")
        }else{
          ids = id+"";
        }
        this.$refs.cancelWin.showCancelWin(ids);
      },
      onCancelSuccess(){
        this.getList();
      },
      selectChange(selection) {
        this.checkData = selection
      },
      getList() {
        let self = this;
        self.dataLoading = true;
        let param = {
          page: self.pageCurrent,
          size:self.size,
          studentId: self.studentId,
          state: self.searchForm.state,
          start: self.searchForm.daterange[0],
          end: self.searchForm.daterange[1]
        }
        self.$api.schedule.getStudentScheduleList(param).then(resp => {
          self.data = resp.data.list;
          self.pageTotalNum = resp.data.totalRow;
          self.totalPage = resp.data.totalPage;
          self.pageCurrent = resp.data.pageNumber;
          self.dataLoading = false;
        });
      },
      changePage(page) {
        this.pageCurrent = page;
        this.getList();
      },
      pageSizeChange (pageSize) {
        this.size=pageSize;
        this.getList();
      },
      doSearch() {
        this.pageCurrent = 1;
        this.getList();
      },
      onCloseForm() {
        this.getList();
      },
      delOneTime(item){
        let self = this;
        self.$Modal.confirm({
          title: '提示',
          content: '是否确定删除该学员本次排课？',
          onOk: () => {
            self.$api.clazz.deleteStudentOne({id:item.id}).then(resp=>{
              if (resp.state == 'ok'){
                self.$Message.success("删除成功");
                self.getList();
              }else{
                self.$Message.error(resp.msg);
              }
            });
          },
          onCancel: () => {

          }
        });
      },
      batchDelete(){
        if (this.checkData.length != 0) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否确定删除所选的该学员排课？',
            onOk: () => {
              let tobeDelArray = [];
              this.checkData.forEach(ele=>{
                tobeDelArray.push(ele.id);
              });
              this.$api.clazz.deleteStudentOne({id:tobeDelArray.join(",")}).then(resp=>{
                if (resp.state == 'ok'){
                  this.$Message.success("删除成功");
                  this.getList();
                }else{
                  this.$Message.error(resp.msg);
                }
              });
            },
            onCancel: () => {

            }
          });
        }else{
          this.$Message.error("未选中任何项");
        }
      },
    },
    mounted: function () {
    },
    computed: {
      showPager: function () {
        return this.totalPage > 1
      },
      studentId:function(){
        return this.$route.query.id
      }
    },
    filters: {
      courseTypeFilter: function (value) {
        if (value == 1) {
          return '一对一';
        } else if (value == 2) {
          return '班课';
        } else {
          return '未知:' + value
        }
      },
      classNameFilter:function(value,schedule){
        if (schedule.className){
          if (schedule.courseType == 1){
            return '【一对一】'+ schedule.className;
          }else{
            return '【班课】'+ schedule.className;
          }
        }else{
          return '【一对一】'+schedule.courseName + "|" + schedule.studentName;
        }

      },
      stateColorFilter:function(state){
        if (state == 1){
          return "default";
        }else if (state == 2){
          return "success";
        }else if (state == 3){
          return "default";
        }else{
          return "error"
        }
      },
      stateTxtFilter:function(state){
        if (state == 1){
          return "未开始";
        }else if (state == 2){
          return "已结束";
        }else if (state == 3){
          return "已取消";
        }else if (state == 4){
          return "课时不足";
        }else{
          return "系统异常"
        }
      },
    }
  }
</script>
